import { ButtonIcon, Flex, Typography } from 'components';
import React from 'react';
import styled from 'styled-components';

// import { Container } from './styles';

interface PagingProps {}

const CustomButtonIcon = styled((props) => <ButtonIcon {...props} />)`
  flex-shrink: 0;
`;

const ButtonGroup = styled((props) => <Flex {...props} />)`
  flex-grow: 0;
  flex-wrap: nowrap;
  border: 2px solid ${({ theme }) => theme.colors.gray_200};
  border-radius: 4px;

  &:first-child {
    ${CustomButtonIcon} {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
  }

  &:last-child {
    ${CustomButtonIcon} {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
  }
`;

interface PagingProps {
  onSearchSubmit: (event?: any) => void;
  currentPage: number;
  totalPages: number;
  setPage: (page: number) => void;
}

const Paging = ({ onSearchSubmit, setPage, currentPage, totalPages }: PagingProps) => {
  return (
    <ButtonGroup>
      <Flex>
        <CustomButtonIcon
          icon="chevronLeft"
          width={50}
          iconWidth={25}
          bg="white"
          bgHover="gray_100"
          color={currentPage > 1 ? 'primary_400' : 'gray_300'}
          justifyContent="center"
          disabled={currentPage <= 1}
          onClick={() => {
            setPage(currentPage - 1);
            onSearchSubmit();
          }}
        />
      </Flex>

      <Flex bg="gray_100" borderLeft="2px solid" borderRight="2px solid" borderColor="gray_200" alignItems="center">
        <Typography px={3} type="type1" color="gray_500">
          {currentPage}
          {' de '}
          {totalPages}
        </Typography>
      </Flex>

      <Flex>
        <CustomButtonIcon
          icon="chevronRight"
          width={50}
          iconWidth={25}
          bg="white"
          bgHover="gray_100"
          color={currentPage < totalPages ? 'primary_400' : 'gray_300'}
          justifyContent="center"
          disabled={currentPage >= totalPages}
          onClick={() => {
            setPage(currentPage + 1);
            onSearchSubmit();
          }}
        />
      </Flex>
    </ButtonGroup>
  );
};

export default Paging;
